import { useRef } from 'react';
import bem from '../../../../utils/bem';
import { getUrlParams } from '../../../../utils/handleSearchParams';

const Tags = ({ settings, onChange }) => {
  const content = useRef(null);
  const {
    state,
    options,
    wrapperClasses = [],
    label,
    mapTo,
    linkTagsCallback, // Use if tags are links with search params.
  } = settings || {};
  const name = mapTo || settings.name;
  const baseClass = 'form-item';

  if (!options || !options.length) {
    return '';
  }
  const objectContainsKeysWithValues = (stateObject, tagObject) => {
    let keysWithValuesExist = true;
    Object.entries(tagObject).forEach(([key, value]) => {
      if (
        !Object.prototype.hasOwnProperty.call(stateObject, key) ||
        (stateObject[key] !== value && !stateObject[key].includes(value))
      ) {
        keysWithValuesExist = false;
      }
    });

    return keysWithValuesExist;
  };

  const renderOptions = options.map((option) => {
    const { value, label: optionLabel } = option;
    let isChecked = false;
    if (typeof linkTagsCallback === 'function') {
      isChecked = objectContainsKeysWithValues(state, getUrlParams(value));
    } else {
      isChecked = state && state[`${name}`] && state[`${name}`].includes(value);
    }

    return (
      <button
        className={bem('tag', [], baseClass, [
          'btn-icon',
          `${isChecked ? 'active' : ''}`,
        ])}
        key={`${name}-${value}`}
        onClick={(event) => {
          if (typeof linkTagsCallback === 'function') {
            linkTagsCallback(value);
          } else {
            onChange(event);
          }
        }}
        data-filter-type="tag"
        data-name={name}
        data-value={value}
        data-checked={isChecked}
      >
        {optionLabel}
      </button>
    );
  });

  return (
    <div className={bem(baseClass, ['tags'], '', wrapperClasses)}>
      {label && <h6>{label}</h6>}
      <div ref={content}>{renderOptions}</div>
    </div>
  );
};

export default Tags;
